export enum ChartType {
  Absolute,
  Rebase,
}
